
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/articles/memory-care",
      function () {
        return require("private-next-pages/resources/articles/memory-care.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/articles/memory-care"])
      });
    }
  